import React from "react";
import {TransitionMotion, spring} from "react-motion/lib/react-motion";


/**
 *
 *
 * https://medium.com/@zrisha/simple-transition-with-react-motion-236ae5f348b1
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export default function TopDownTransition(props) {


    let defaultStyles = [], styles = [];

    React.Children.forEach(props.children, (child, i) => {
        if (child) {
            defaultStyles.push({
                key: child.key,
                data: child,
                style: {
                    y: -100,
                    opacity: 0
                }
            });
            styles.push({
                key: child.key,
                data: child,
                style: {
                    y: spring(0, {stiffness: 170, damping: 26}),
                    opacity: spring(1, {stiffness: 170, damping: 26})
                }
            });
        }
    });

    const willEnter = () => {
        return {
            y: spring(200, {stiffness: 170, damping: 26}),
            opacity: spring(0, {stiffness: 170, damping: 26})
        }
    };
    const willLeave = () => {
        return {
            y: spring(-100, {stiffness: 170, damping: 26}),
            opacity: spring(0, {stiffness: 170, damping: 26})
        }
    };

    return <TransitionMotion
        defaultStyles={defaultStyles}
        styles={styles}
        //willEnter={willEnter}
        willLeave={willLeave}
    >
        {
            (styles) => <div> {
                styles.map((child) => {
                    const {key, data, style} = child;

                    //console.log("translationY", style.y);
                    const childStyle = {
                        opacity: style.opacity,
                        transform: `translateY(${style.y}px)`
                    };

                    // console.log("style", style.y, style.opacity);

                    return React.cloneElement(
                        data,
                        {key: key, style: childStyle}
                    );
                })}
            </div>
        }
    </TransitionMotion>
}